import { useQuery } from "@tanstack/react-query";

import { fetchSession } from "../api-client";

export const SESSION_QUERY_KEY = ["session"] as const;

export function useSession() {
  return useQuery({
    queryKey: SESSION_QUERY_KEY,
    queryFn: fetchSession,
    staleTime: 60_000,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
